module.exports = __webpack_public_path__ + "img/item4-2.b328b6e0.jpg";